import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=7c61e112&scoped=true&"
import script from "./ImageWidget.vue?vue&type=script&lang=js&"
export * from "./ImageWidget.vue?vue&type=script&lang=js&"
import style0 from "./ImageWidget.vue?vue&type=style&index=0&id=7c61e112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c61e112",
  null
  
)

export default component.exports